import { AlertTriangle, CheckCircle2, MapPin } from "lucide-react";

export const facilityTone = (f) => (f.open === 0 ? "danger" : f.outOfService > 0 ? "caution" : "safe");

export const FacilityCard = ({ f, onOpen, t }) => {
  const tone = facilityTone(f);
  return (
    <button type="button" className={`card ust-fac tone-border-${tone}`} onClick={() => onOpen(f)} data-testid={`ust-facility-${f.facilityId}`}>
      <div className="ust-fac-top"><b>{f.name}</b>{f.feet != null && <span className="card-sub">{f.feet.toLocaleString()} ft</span>}</div>
      <div className="card-sub ust-addr"><MapPin size={12} /><span>{f.address}</span></div>
      <div className="ust-counts" data-testid={`ust-counts-${f.facilityId}`}>
        <span className="ust-ok">{t("Open: {n}", { n: f.open })}</span>
        {f.outOfService > 0 && <span className="ust-warn">{t("Out of service: {n}", { n: f.outOfService })}</span>}
        <span>{t("Closed: {n}", { n: f.closed })}</span>
      </div>
      {tone === "danger" && <div className="ust-flag tone-danger" data-testid={`ust-flag-${f.facilityId}`}><AlertTriangle size={14} />{t("No open tanks on file. This store may be out of service.")}</div>}
      {tone === "caution" && <div className="ust-flag tone-caution" data-testid={`ust-flag-${f.facilityId}`}><AlertTriangle size={14} />{t("Some tanks are marked out of service.")}</div>}
      {tone === "safe" && <div className="ust-flag tone-safe"><CheckCircle2 size={14} />{t("Tanks in service")}</div>}
    </button>
  );
};
